import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Icon } from "./../../../Common/Icon";
import { downloadDocuments } from "../../../../actions";

class DocumentLinkCell extends PureComponent {
  static propTypes = {
    documentId: PropTypes.string.isRequired,
    documentName: PropTypes.string.isRequired,
    downloadDocuments: PropTypes.func.isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    className: ""
  };

  handleClick = () => this.props.downloadDocuments(this.props.documentId, this.props.documentName);

  render() {
    return (
      <div role="cell" className={classNames("sorted-list__data --center", this.props.className)}>
        <button className="button" onClick={this.handleClick}>
          <Icon id="download" className="button__download-icon" />
        </button>
      </div>
    );
  }
}

export default connect(
  null,
  { downloadDocuments }
)(DocumentLinkCell);



// WEBPACK FOOTER //
// ./src/components/Common/Document/List/DocumentLinkCell.js